
import XTable from 'vux/src/components/x-table/index.vue'

import {mapMutations} from 'vuex'
export default {
name: 'PCL',
data() {
return {}
},
components: {
XTable
},
created() {
this.hideLoad();
},
methods: {
...mapMutations(["hideLoad"]),
},
}



// WEBPACK FOOTER //
// ./src/pages/formulas/HD/PCL.vue